<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3" outlined style="overflow: auto;">
            <PointTiers :tiers="tiers" />
        </v-sheet>
    </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
// import PointTitleForm from "../../components/loyaltyPanel/pointTitles/PointTitleForm";
import PointTiers from "../../components/loyaltyPanel/pointTitles/PointTiers";
import translations from "@/utils/translations/loyaltyPanel/pointTitles";

export default {
    name: "PointTitles",

    components: { PointTiers },

    mixins: [translations],

    data() {
        return {};
    },

    computed: {
        ...mapState(["loading", "errorMessage"]),
        tiers: {
            get() {
                return this.$store.state.loyaltyPanel.pointTitles.tiers;
            },
            set(val) {
                this.setTiers(val);
            }
        },

        lang() {
            return this.$route.params.lang;
        },

    },
};
</script>
